export default __webpack_public_path__ + "static/media/cyara-logo-white.33abeae3.svg";